"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', /*#__PURE__*/function (_HTMLElement) {
    _inherits(MediaGallery, _HTMLElement);
    var _super = _createSuper(MediaGallery);
    function MediaGallery() {
      var _this;
      _classCallCheck(this, MediaGallery);
      _this = _super.call(this);
      _this.elements = {
        liveRegion: _this.querySelector('[id^="GalleryStatus"]'),
        viewer: _this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: _this.querySelector('[id^="GalleryThumbnails"]')
      };
      _this.mql = window.matchMedia('(min-width: 750px)');
      _this.previousActiveMedia = null;
      if (!_this.elements.thumbnails) return _possibleConstructorReturn(_this);
      _this.elements.viewer.addEventListener('slideChanged', _this.onSlideChanged.bind(_assertThisInitialized(_this)));
      _this.elements.thumbnails.querySelectorAll('[data-target]').forEach(function (mediaToSwitch) {
        mediaToSwitch.querySelector('button').addEventListener('click', _this.setActiveMedia.bind(_assertThisInitialized(_this), mediaToSwitch.dataset.target, false));
      });
      if (_this.dataset.desktopLayout.includes('thumbnail') && _this.mql.matches) _this.removeListSemantic();
      return _this;
    }

    // simplified onSlideChanged to use playActiveMedia directly
    // This ensures arrow navigation matches thumbnail click behavior
    _createClass(MediaGallery, [{
      key: "onSlideChanged",
      value: function onSlideChanged(event) {
        var currentSlide = event.detail.currentElement;
        var thumbnail = this.elements.thumbnails.querySelector("[data-target=\"".concat(currentSlide.dataset.mediaId, "\"]"));
        this.setActiveThumbnail(thumbnail);
        // Ensure proper is-active class management for arrow clicks (matches thumbnail click behavior)
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(function (element) {
          element.classList.remove('is-active');
        });
        currentSlide.classList.add('is-active');
        this.playActiveMedia(currentSlide); // Handles video pause/play and deferred-media loading
      }
    }, {
      key: "setActiveMedia",
      value: function setActiveMedia(mediaId, prepend) {
        var _activeMedia$classLis,
          _this2 = this;
        var activeMedia = this.elements.viewer.querySelector("[data-media-id=\"".concat(mediaId, "\"]")) || this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(function (element) {
          element.classList.remove('is-active');
        });
        activeMedia === null || activeMedia === void 0 ? void 0 : (_activeMedia$classLis = activeMedia.classList) === null || _activeMedia$classLis === void 0 ? void 0 : _activeMedia$classLis.add('is-active');
        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            var _activeThumbnail = this.elements.thumbnails.querySelector("[data-target=\"".concat(mediaId, "\"]"));
            _activeThumbnail.parentElement.firstChild !== _activeThumbnail && _activeThumbnail.parentElement.prepend(_activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
        this.preventStickyHeader();
        window.setTimeout(function () {
          if (!_this2.mql.matches || _this2.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft
            });
          }
          var activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          var top = activeMediaRect.top + window.scrollY;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        });
        this.playActiveMedia(activeMedia);
        if (!this.elements.thumbnails) return;
        var activeThumbnail = this.elements.thumbnails.querySelector("[data-target=\"".concat(mediaId, "\"]"));
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }, {
      key: "setActiveThumbnail",
      value: function setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach(function (element) {
          return element.removeAttribute('aria-current');
        });
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft
        });
      }
    }, {
      key: "announceLiveRegion",
      value: function announceLiveRegion(activeItem, position) {
        var _this3 = this;
        var image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = function () {
          _this3.elements.liveRegion.setAttribute('aria-hidden', false);
          _this3.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(function () {
            _this3.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }
    }, {
      key: "playActiveMedia",
      value: function playActiveMedia(activeItem) {
        // Pause media in the previously active item (if it's different from current)
        if (this.previousActiveMedia && this.previousActiveMedia !== activeItem) {
          window.pauseAllMedia(this.previousActiveMedia);

          // Remove .is-active class from previous deferred-media
          var prevDeferredMedia = this.previousActiveMedia.querySelector('.deferred-media');
          if (prevDeferredMedia) {
            prevDeferredMedia.classList.remove('is-active');
          }
          if (window.matchMedia('(max-width: 749px)').matches) {
            var prevModalOpener = this.previousActiveMedia.querySelector('.product__modal-opener--video');
            if (prevModalOpener) {
              prevModalOpener.style.display = '';
            }
          }
        }
        // This ensures deferred-media-auto is used instead of zoom modal
        if (window.matchMedia('(max-width: 749px)').matches) {
          var modalOpener = activeItem.querySelector('.product__modal-opener--video');
          if (modalOpener) {
            modalOpener.style.display = 'none';
          }
        }

        // Play/load media in the current active item
        var deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          // Add .is-active class to show it on mobile
          deferredMedia.classList.add('is-active');
          deferredMedia.loadContent(false);

          // Use a small timeout to ensure the video element is in the DOM before playing
          // This is necessary for mobile browsers to allow autoplay after user interaction (arrow click)
          setTimeout(function () {
            var video = deferredMedia.querySelector('video');
            if (video) {
              // Ensure autoplay happens
              video.play()["catch"](function (err) {
                // Log if play fails (browser restrictions, etc)
                console.log('Video autoplay prevented:', err);
              });
            }
          }, 50);
        }

        // Update the previous active item
        this.previousActiveMedia = activeItem;
      }
    }, {
      key: "preventStickyHeader",
      value: function preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    }, {
      key: "removeListSemantic",
      value: function removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.sliderItems.forEach(function (slide) {
          return slide.setAttribute('role', 'presentation');
        });
      }
    }]);
    return MediaGallery;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
}